import CandidateNotesPageContent from '@/components/CandidateNotesPageContent';
import { Candidate } from '@/services/candidates';

type CandidateInfoComponentProps = {
  candidate?: Candidate;
  refetchCandidate: () => void;
};

const CandidateInfoComponent = function ({
  candidate,
  refetchCandidate,
}: CandidateInfoComponentProps): JSX.Element {
  return (
    <div data-testid="candidate-notes-page">
      {candidate && (
        <CandidateNotesPageContent candidate={candidate} onRefetchCandidate={refetchCandidate} />
      )}
    </div>
  );
};

export default CandidateInfoComponent;
